import React from "react";

// Компонент для вибору діапазонів дат
const DateRangePicker = ({ value, onChange }) => {
  const { startDate, endDate } = value || { startDate: "", endDate: "" };

  // Обробка зміни початкової дати
  const handleStartDateChange = (e) => {
    onChange({ startDate: e.target.value || null, endDate });
  };

  // Обробка зміни кінцевої дати
  const handleEndDateChange = (e) => {
    onChange({ startDate, endDate: e.target.value || null });
  };

  return (
    <div className="date-range-picker">
      <input
        type="date"
        value={startDate || ""}
        onChange={handleStartDateChange}
        aria-label="Start Date"
      />
      <span style={{ display: "flex", alignItems: "center" }}>–</span>
      <input
        type="date"
        value={endDate || ""}
        onChange={handleEndDateChange}
        aria-label="End Date"
        min={startDate || undefined} // Запобігає введенню раніше початкової дати
      />
    </div>
  );
};

export default DateRangePicker;
